module.exports = __webpack_public_path__ + "static/media/down-arrow.b7ac2eba.svg";